export class ConfirmPopupInfo {
    sessionId: number;
    patientId: number;
    clinicianId: number;
    latitude: any;
    longitude: any;
    clinicianName: string;
    waitingRoomId: number;
    isReconnect: boolean;
    dbSessionId: any;
    patientname: string;
    timerOff: boolean;
    appointmentDt: any;
    appointmentId: number;
}
